import React, { useEffect, useState } from 'react';
import DashboardListIcons from '../Dashboard/DashboarListIcon/DashboardListIcons';
// import TopNav from "../Dashboard/Top-Nav/TopNav";
import ProcedureListing from './ProcedureListing';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { api } from '../../Api-Endpoints/apiEndpoint';
import { LoadProcedures } from '../../Redux/ProcedureReducer';
import Layout from '../layout/Layout';
import { useParams } from 'react-router-dom';

const Procedures = () => {
  const params = useParams();
  return (
    <Layout heading={'Procedures'}>
      <ProcedureListing params={params} />
    </Layout>
  );
};

export default Procedures;
